import { createSlice } from '@reduxjs/toolkit';
import { post } from '../../api';

export const checklistSlice = createSlice({
    // Slice name, this should be always as page name.
    name: 'checklist',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },

    // Reducers will mutate the state, put all the state mutation method over here
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        loading: (state, action) => {
            state.status = action.payload ? 'loading' : 'succeeded';
        },
        initialLoading: (state, action) => {
            state.status = action.payload ? 'initialLoading' : 'succeeded';
        },
        updateChecklist: (state, action) => {
            const checklist = action.payload.checklist;
            let isExist = false;
            state.data.records = state.data.records.map((record) => {
                if (record.id === checklist.id) {
                    isExist = true;
                    return checklist;
                }
                return record;
            });

            if (!isExist) {
                state.data.records.push(checklist);
            }
        },
        removeChecklist: (state, action) => {
            const checklist = action.payload.checklist;
            state.data.records = state.data.records.filter((record) => {
                if (record.id === checklist.id) {
                    return false;
                }
                return true;
            });
        },
    },
});

export default checklistSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading, updateChecklist, removeChecklist } = checklistSlice.actions;

// Public Selectors
export const selectChecklistData = (state) => state.checklist.data;
export const selectChecklistStatus = (state) => state.checklist.status;
export const selectChecklistError = (state) => state.checklist.error;

export const initializeAsync = (params) => async (dispatch) => {
    dispatch(initialLoading(true));
    const result = await post('custom/getChecklistTasks', { accountIds: params.accountIds });
    if (result.isSuccess) {
        dispatch(initialize({ records: result.data }));
    } else {
        dispatch(error(result.errorMessage));
    }
};

export const initializeWithoutLoadAsync = (params) => async (dispatch) => {
    const result = await post('custom/getChecklistTasks', { accountIds: params.accountIds });
    if (result.isSuccess) {
        dispatch(initialize({ records: result.data }));
    } else {
        dispatch(error(result.errorMessage));
    }
};

export const updateChecklistAsync = (checklist) => async (dispatch) => {
    dispatch(updateChecklist({ checklist }));
    if (checklist.companyTasks?.length > 0) {
        let companyTaskIds = checklist.companyTasks.map((item) => {
            return item.id;
        });

        post('custom/updateCompanyTasksStatus', { recordId: companyTaskIds, status: checklist.companyTasks[0].status });
    }
};

export const removeChecklistAsync = (checklist) => async (dispatch) => {
    dispatch(removeChecklist({ checklist }));
    post('custom/deleteTask', { id: checklist.id }).then((result) => {
        if (result.isSuccess && result.data === 'Success') {
            let messageDetail = { variant: 'success', message: 'Task deleted successfully' };
            const event = new CustomEvent('openToster', {
                detail: messageDetail,
            });

            document.dispatchEvent(event);
        } else {
            let messageDetail = { variant: 'error', message: 'There was an error deleting the task, please contact agent' };
            const event = new CustomEvent('openToster', {
                detail: messageDetail,
            });

            document.dispatchEvent(event);
        }
    });
};
